// extracted by mini-css-extract-plugin
export var cardWrapper = "search-wrapper-module--cardWrapper--a0b1c";
export var container = "search-wrapper-module--container--6c5e2";
export var iconCircle = "search-wrapper-module--iconCircle--522de";
export var logo = "search-wrapper-module--logo--8342a";
export var phone = "search-wrapper-module--phone--b1bd3";
export var phoneIcon = "search-wrapper-module--phoneIcon--9ab10";
export var searchBar = "search-wrapper-module--searchBar--267e5";